import { blue, grey } from '@ant-design/colors'
import { Card, Divider, Typography } from 'antd'
import { JobForInvoicing } from '../../../../../domain/invoicing/invoice'
import VSpace from '../../../../common/VSpace'
import TruncatedName from '../../../../common/TruncatedName'
import JobTypeTag from '../../../JobTypeTag'
import { visitsLabel } from '../editorDrawerModel'

const { Text } = Typography

type Props = {
  job: JobForInvoicing
  isSelected: boolean
  onSelectJob: (jobId: number) => void
}

const JobCard = ({ job, isSelected, onSelectJob }: Props) => {
  return <Card
    style={{
      borderRadius: 8,
      cursor: 'pointer',
      border: isSelected ? `1px solid ${blue.primary}` : '1px solid #f0f0f0',
      backgroundColor: isSelected ? blue[0] : '#fff',
    }}
    role="button"
    tabIndex={0}
    aria-pressed={isSelected}
    onKeyDown={event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault()
        onSelectJob(job.id)
      }
    }}
    onClick={() => onSelectJob(job.id)}
  >
    <VSpace style={{ width: '100%' }}>
      <Text strong>
        <TruncatedName name={job.customer?.displayName ?? ''} />
      </Text>
      <TruncatedName name={job.name} />
      <div>
        <Text strong>{visitsLabel(job.visitsCount)}</Text>
        {job.lastVisitDate && <>
          <Divider type='vertical' style={{ borderColor: grey.primary }} />
          <Text type='secondary'>Last visit {job.lastVisitDate}</Text>
        </>}
      </div>
      <JobTypeTag type={job.type} />
    </VSpace>
  </Card>
}

export default JobCard
